import React from "react";
import { BlockMath, InlineMath } from "react-katex";
import TheoryExamplesRunner from "../../components/TheoryExamplesRunner";

export default function PrismsPyramidsPreparationTheory() {
  const intro = (
    <div className="space-y-3">
      <p>
        Graniastosłup i ostrosłup zaczynamy od tej samej czynności: obliczamy
        pole podstawy <InlineMath math="P_p" /> i wskazujemy wysokość bryły
        <InlineMath math="H" />. Wysokość jest odcinkiem prostopadłym do
        płaszczyzny podstawy.
      </p>
      <BlockMath math={String.raw`V_{\text{graniastosłupa}}=P_p\cdot H`} />
      <BlockMath math={String.raw`V_{\text{ostrosłupa}}=\frac13P_p\cdot H`} />
      <p>
        Przy takim samym polu podstawy i tej samej wysokości ostrosłup ma
        objętość trzy razy mniejszą od graniastosłupa. W zadaniach o polu
        całkowitym osobno liczymy podstawy i ściany boczne.
      </p>
      <BlockMath math={String.raw`P_c^{\text{graniastosłupa}}=2P_p+P_b,\qquad P_c^{\text{ostrosłupa}}=P_p+P_b`} />
      <p>
        Jeżeli podstawa jest <InlineMath math="n" />-kątem, liczbę ścian,
        krawędzi i wierzchołków odczytujemy z prostych zależności:
      </p>
      <BlockMath
        math={String.raw`\begin{aligned}
          \text{graniastosłup:}\quad&s=n+2,\quad k=3n,\quad w=2n,\\
          \text{ostrosłup:}\quad&s=n+1,\quad k=2n,\quad w=n+1.
        \end{aligned}`}
      />
    </div>
  );

  const examples = [
    {
      label: "Przykład 1",
      summary: "Objętość graniastosłupa",
      description: "Pole podstawy wynosi 18 cm², a wysokość 7 cm.",
      content: <BlockMath math={String.raw`V=P_p\cdot H=18\cdot7=126\,\text{cm}^3`} />,
    },
    {
      label: "Przykład 2",
      summary: "Objętość ostrosłupa",
      description: "Pole podstawy wynosi 18 cm², a wysokość 7 cm.",
      content: <BlockMath math={String.raw`V=\frac13P_p\cdot H=\frac13\cdot18\cdot7=42\,\text{cm}^3`} />,
    },
    {
      label: "Przykład 3",
      summary: "Przekątna sześcianu",
      description: "Krawędź sześcianu ma długość 4 cm.",
      content: (
        <div>
          <BlockMath math={String.raw`d=a\sqrt3=4\sqrt3\,\text{cm}`} />
          <p>
            Wzór wynika z dwukrotnego zastosowania twierdzenia Pitagorasa:
            najpierw w podstawie, a następnie w przekroju sześcianu.
          </p>
        </div>
      ),
    },
    {
      label: "Przykład 4",
      summary: "Krawędzie, ściany i wierzchołki",
      description:
        "Porównujemy graniastosłup i ostrosłup o podstawie pięciokąta.",
      content: (
        <div>
          <BlockMath
            math={String.raw`\begin{aligned}
              \text{graniastosłup:}\quad&s=7,\quad k=15,\quad w=10,\\
              \text{ostrosłup:}\quad&s=6,\quad k=10,\quad w=6.
            \end{aligned}`}
          />
          <p>
            W obu przypadkach podstawiamy <InlineMath math="n=5" /> do
            odpowiednich wzorów.
          </p>
        </div>
      ),
    },
  ];

  return <TheoryExamplesRunner intro={intro} examples={examples} />;
}
